import React from "react";
import { money } from "./helpers";

export default function DeleteCommissionModal({
  commission, currenciesById, paymentCurrency,
  error, deleting, onClose, onConfirm,
}) {
  if (!commission) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onMouseDown={(e) => { if (e.target === e.currentTarget && !deleting) onClose(); }}
    >
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <h2 className="text-xl font-bold text-slate-900">Удалить комиссию?</h2>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          Заказ: <strong>{commission.order_code}</strong>
          <br />
          Сумма:{" "}
          <strong>{money(commission.amount, currenciesById[commission.currency] || paymentCurrency)}</strong>
        </p>
        {error && (
          <div className="mt-3 whitespace-pre-wrap rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            {error}
          </div>
        )}
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            disabled={deleting}
            onClick={onClose}
            className="rounded-lg border border-slate-300 px-4 py-2.5 text-sm font-medium hover:bg-slate-50 disabled:opacity-50"
          >
            Отмена
          </button>
          <button
            type="button"
            disabled={deleting}
            onClick={onConfirm}
            className="rounded-lg bg-red-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
          >
            {deleting ? "Удаление…" : "Удалить"}
          </button>
        </div>
      </div>
    </div>
  );
}